import { Box } from "@mui/material";
import React from "react";

/**
 * The narrowest a tile gets. The grid fits as many tiles of at least this
 * width as the panel allows and stretches them to fill the row, so a tile
 * lands near the size the end-customer wizard gives its options.
 */
const TILE_MIN_WIDTH = 160;

/** The grid every wizard renderer lays its option tiles out in. */
export const WizardTileGrid = ({
  label,
  children,
}: React.PropsWithChildren<{ label: string }>) => (
  <Box
    role="group"
    aria-label={label}
    sx={{
      display: "grid",
      gridTemplateColumns: `repeat(auto-fill, minmax(${TILE_MIN_WIDTH}px, 1fr))`,
      gap: 1,
      width: "100%",
    }}
  >
    {children}
  </Box>
);
